import React from "react";
import {
  StyledFooterHistoryApprovalContainer,
  StyledFooterHistoryApprovalContent,
  StyledFooterLeftContainer,
} from "./FooterHistoryApproval.styled";

type FooterHistoryApprovalProps = {
  leftContent?: React.ReactNode;
  rightContent: React.ReactNode;
};

export const FooterHistoryApproval = ({
  leftContent,
  rightContent,
}: FooterHistoryApprovalProps) => {
  return (
    <StyledFooterHistoryApprovalContainer>
      <StyledFooterHistoryApprovalContent>
        <StyledFooterLeftContainer>{leftContent}</StyledFooterLeftContainer>
        {rightContent}
      </StyledFooterHistoryApprovalContent>
    </StyledFooterHistoryApprovalContainer>
  );
};
